import { environment } from "../Environment/Environment";
import { API } from "../api_layer/baseApi";

export const authorizationService = {

   login(key: any, payLoad: any, options = {}) {
      const path = environment.test + 'login';
      return API.post(path, key, payLoad, options);
   },

   logout(key: any, payLoad: any, options = {}) {
      const path = environment.test + 'logout';
      return API.post(path, key, payLoad, options);
   },

   detectedDevicesList(key: any, payLoad: any, device: any, version: any, options = {}) {
      const path = environment.test + device + '/' + version + '/device/remote/getDevice';
      return API.post(path, key, payLoad, options);
   },

   getUrlData(key: any, payLoad: any, device: any, version: any, options = {}) {
      const path = environment.test + device + '/' + version + '/device/remote/getURLData';
      return API.post(path, key, payLoad, options);
   },

   updateUrlData(key: any, payLoad: any, device: any, version: any, options = {}) {
      const path = environment.test + device + '/' + version + '/device/remote/updateURLData';
      return API.post(path, key, payLoad, options);
   },

   deleteProtocol(key: any, payLoad: any, device: any, version: any, options = {}) {
      const path = environment.test + device + '/' + version + '/device/remote/deleteDevice';
      return API.post(path, key, payLoad, options);
   },

   getLicenseDetails(key: any, payLoad: any, device: any, version: any, options = {}) {
      const path = environment.test + device + '/' + version + '/device/remote/getLicense';
      return API.post(path, key, payLoad, options);
   },

   getMetaData(key: any, payLoad: any, device: any, version: any, options = {}) {
      const path = environment.test + device + '/' + version + '/device/remote/getDeviceMetadata';
      return API.post(path, key, payLoad, options);
   },

   getEditMetaData(key: any, payLoad: any, device: any, version: any, options = {}) {
      const path = environment.test + device + '/' + version + '/device/remote/getEditMetadata';
      return API.post(path, key, payLoad, options);
   },

   getDeviceParameter(key: any, payLoad: any, device: any, version: any, options = {}) {
      const path = environment.test + device + '/' + version + '/device/remote/getDeviceParameter';
      return API.post(path, key, payLoad, options);
   },

   addDevice(key: any, payLoad: any, device: any, version: any, options = {}) {
      const path = environment.test + device + '/' + version + '/device/remote/addDevice';
      return API.post(path, key, payLoad, options);
   },

   updateDevice(key: any, payLoad: any, device: any, version: any, options = {}) {
      const path = environment.test + device + '/' + version + '/device/remote/updateDevice';
      return API.post(path, key, payLoad, options);
   },

   getNormalizerData(key: any, payLoad: any, device: any, version: any, options = {}) {
      const path = environment.test + device + '/' + version + '/device/remote/getNormalizerConfig';
      return API.post(path, key, payLoad, options);
   },

   getRule(key: any, payLoad: any, device: any, version: any, options = {}) {
      const path = environment.test + device + '/' + version + '/device/remote/getRuleConfig';
      return API.post(path, key, payLoad, options);
   },

   updateNormalizer(key: any, payLoad: any, device: any, version: any, options = {}) {
      const path = environment.test + device + '/' + version + '/device/remote/updateNormalizerConfig';
      return API.post(path, key, payLoad, options);
   },
   updateRule(key: any, payLoad: any, device: any, version: any, options = {}) {
      const path = environment.test + device + '/' + version + '/device/remote/updateRuleConfig';
      return API.post(path, key, payLoad, options);
   },

   getModuleConfigData(key: any, payLoad: any, device: any, version: any, options = {}) {
      const path = environment.test + device + '/' + version + '/device/remote/getModuleConfig';
      return API.post(path, key, payLoad, options);
   },

   updateModuleConfigData(key: any, payLoad: any, device: any, version: any, options = {}) {
      const path = environment.test + device + '/' + version + '/device/remote/updateModuleConfig';
      return API.post(path, key, payLoad, options);
   },

   handleConfigJson(key: any, payLoad: any, device: any, version: any, options = {}) {
      const path = environment.test + device + '/' + version + '/device/remote/handleConfigJSON';
      return API.post(path, key, payLoad, options);
   },

   getJsonData(key: any, payLoad: any, device: any, version: any, options = {}) {
      const path = environment.test + device + '/' + version + '/device/remote/handleConfigJSON';
      return API.get(path, key, undefined, options);
   }
   ,
   updateLicense(key: any, payLoad: any, device: any, version: any, options = {}) {
      const path = environment.test + device + '/' + version + '/device/remote/updateLicense';
      return API.post(path, key, payLoad, options);
   },

   downloadLog(key: any, payLoad: any, device: any, version: any, deviceID: any, options = {}) {
      const path = environment.test + device + '/' + version + '/device/remote/downloadLogFile/' + deviceID;
      // return path;
      return API.get(path, key, undefined, options);
   },

   getDeviceStatus(key: any, payLoad: any, device: any, version: any, options = {}) {
      const path = environment.test + device + '/' + version + '/device/remote/getDeviceStatus';
      return API.post(path, key, payLoad, options);
   },
};